module.exports = __webpack_public_path__ + "static/media/linkedin-white.b461bd7e.svg";